import Model from "../Model";

class Grouptocompanymessage extends Model{

    buildUrl() {
        return ['internalmessage/sendallgroup'];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }

    create(form) {
        return this.request({
            action: 'store',
            method: 'POST',
            data: form
        });
    }
}


export default new Grouptocompanymessage;